import React from "react";

import {
  FiPlus,
  FiRefreshCcw,
  FiSearch,
} from "react-icons/fi";

import "./UserFilters.css";

const USER_STATUS_OPTIONS = [
  {
    value: "",
    label: "All Status",
  },
  {
    value: "ACTIVE",
    label: "Active",
  },
  {
    value: "INACTIVE",
    label: "Inactive",
  },
  {
    value: "BLOCKED",
    label: "Blocked",
  },
];

const UserFilters = ({
  filters,
  setFilters,
  handleSearch,
  handleReset,
  handleAddUser,
  loading = false,
}) => {
  const handleChange = (
    event
  ) => {
    const {
      name,
      value,
    } = event.target;

    setFilters((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleKeyDown = (
    event
  ) => {
    if (
      event.key === "Enter"
    ) {
      event.preventDefault();
      handleSearch();
    }
  };

  return (
    <div className="user-filter-card">
      <div className="user-filter-grid">
        <div className="user-filter-field user-filter-search-field">
          <label htmlFor="user-search">
            Search Customer
          </label>

          <div className="user-filter-input-wrapper">
            <FiSearch />

            <input
              id="user-search"
              type="text"
              name="search"
              value={
                filters?.search || ""
              }
              onChange={handleChange}
              onKeyDown={
                handleKeyDown
              }
              placeholder="Search by name, mobile or email"
              disabled={loading}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="user-filter-field">
          <label htmlFor="user-status">
            Status
          </label>

          <select
            id="user-status"
            name="status"
            value={
              filters?.status || ""
            }
            onChange={handleChange}
            disabled={loading}
          >
            {USER_STATUS_OPTIONS.map(
              (option) => (
                <option
                  key={
                    option.value ||
                    "all"
                  }
                  value={
                    option.value
                  }
                >
                  {option.label}
                </option>
              )
            )}
          </select>
        </div>

        <div className="user-filter-actions">
          <button
            type="button"
            className="user-filter-search-button"
            onClick={
              handleSearch
            }
            disabled={loading}
          >
            <FiSearch />

            Search
          </button>

          <button
            type="button"
            className="user-filter-reset-button"
            onClick={
              handleReset
            }
            disabled={loading}
          >
            <FiRefreshCcw />

            Reset
          </button>

          <button
            type="button"
            className="user-filter-add-button"
            onClick={
              handleAddUser
            }
            disabled={loading}
          >
            <FiPlus />

            Add Customer
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserFilters;